import React, { Component } from 'react';
import {connect} from 'react-redux';
import {eapiClient, aemHostClient} from '../../../../restClient';
import {setDarkTitleBarContent} from '../../../layouts/actions/actionCreator';
import {setLandingActiveTab} from '../../../CaseBody/actions/actionCreator';
import NavListAccordion, {NavListAccordionWrapper} from '../../../common/NavListAccordion/NavListAccordion';
import {Translations, convertStringToArrayForOption} from '../../../../utils';
import PropTypes from 'prop-types';
import BasicDetail from './BasicDetail';
import CountryAndAccount from './CountryAndAccount';
import IeTierAndSetting from './IeTierAndSetting';
import DetailedSetting from './DetailedSetting';
import EchannelReporting from './EchannelReporting';

// css import
import './PreviewIE.css';

// Interest Enhancement Preivew Request
class PreviewIE extends Component{
  constructor(props) {
    super(props);
    this.state = {
      data: this.props.data !== undefined ? this.props.data : {},
      metaData: {},
      title: false,
      originalData:this.props.echannels !== undefined ? this.props.echannels : undefined
    };
  }

  translations = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    return currentWord;
  }

  translateWordForOption = (word) => {
    var currentWord = Translations(word,this.props.lang.currentLang.lang, this.props.lang.translatedData)
    var convertedArray = convertStringToArrayForOption(currentWord);
    return convertedArray;
  }

  componentWillMount(){

      if(this.props.match !== undefined){
        var {caseId} = this.props.match.params;
        eapiClient(`/product/gls/${caseId}/preview-request`, {method: 'GET'})
        .then(({data}) => {
          // gls
          this.setState({
            data: data.responseData,
            title: true
          })
          this.state.originalData === undefined && eapiClient(`/cases/${data.responseData.caseId}/previewRequest`, {method: 'GET'})
          .then(({data, status}) => {

             this.setState({
               originalData : data.responseData.productDetails.eChannels !== undefined &&  data.responseData.productDetails.eChannels.length > 0 ?  data.responseData.productDetails.eChannels : []
             });
            });
        });
      }

      // metadata
      aemHostClient("/aemData/formData/json_preview-interest-enhancement")
      .then(({data, status}) => {
        let heading='Interest Ehnhancment';
        document.title = `${heading} - ${'HSBC GLCM'}`;
        this.setState({
          metaData: data.par
        })
        //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
      });

      aemHostClient("/aemData/formData/json_dark-title-bar")
      .then(({data, status}) => {
        //this.props.setDarkTitleBarContent(heading, true, Translations(data.par.static_text_darkTitleBar.exitCase,this.props.lang.currentLang.lang, this.props.lang.translatedData), "icon icon-delete", currentCase);
      });

      aemHostClient("/aemData/formData/json_preview-request-open")
      .then(({data, status}) => {
        this.setState({
          pageJson:data.par
        })
      });
  }

  getCountryTaxonomy=(item)=>{
    if(this.props.countryList !== undefined){
              this.props.countryList.filter(countItem => {
                if ('country' in item) {
                  if (countItem.id === item.country.value) {
                    item.country.name = countItem.name
                    }
                  }else{
                    if (countItem.id === item.value) {
                      item.name = countItem.name
                      }
                  }
                })
                return item;
              }
      }

      getProductRelatedTaxonomy(product){
        if (product !== undefined) {
           this.props.accountCountryList.filter(countItem => {
              if ('country' in product) {
                if (countItem.id === product.country.value) {
                  product.country.name = countItem.name
                    if(product.accountType !== undefined){
                      countItem.associations.filter(accountType =>
                      {
                      if(accountType.id === product.accountType.value){
                        product.accountType.name = accountType.name
                          }
                      })
                  }} }
            });
            return product;
    }
    }

  eventToGoCase = () => {
    this.props.setLandingActiveTab(1);
    this.props.history.push('/case-list');
  }

  render(){
    if(this.state.pageJson !== undefined && this.state.data !== undefined && this.state.metaData !== undefined){
      const tabTitleHtml = (
        <div className="ie-navigation">
           <div className="title">
              {
                this.state.metaData !== undefined && this.state.metaData.staticText_previewData !== undefined
                ? `${this.translations(this.state.metaData.staticText_previewData.title)} >`
                : `Interest Enhancement  >`
              }
           </div>
           <span>{`${this.state.data.glsAgent !== undefined ? this.state.data.glsAgent.name : ''}`}</span>
         </div>
       );

      return (
        <div>
          <div className="ie-preview-request-container">
            {
              this.state.title &&
              <div className="gdoc-preview-request-preview-request border-bottom-none">
                <span>
                {
                  this.state.metaData !== undefined && this.state.metaData.staticText_previewData !== undefined
                  ? `${this.translations(this.state.metaData.staticText_previewData.title)}`
                  : `Interest Enhancement`
                }
                </span>
              </div>
            }

            <div className="ie-container">
              <NavListAccordionWrapper>
                <NavListAccordion
                  navAccHeading={tabTitleHtml}
                >
                  {
                    this.state.metaData.staticText_previewBasicDetail !== undefined
                    ? <BasicDetail
                        data={this.state.data}
                        pageJson={this.state.metaData.staticText_previewBasicDetail}
                        translations={(word) => this.translations(word)}
                        countryList= {this.props.countryList}
                        getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                      />
                    : null
                  }
                  {
                    this.state.metaData.staticText_previewCountryAccount !== undefined
                    ? <CountryAndAccount
                        data={this.state.data}
                        history={this.props.history}
                        pageJson={this.state.metaData.staticText_previewCountryAccount}
                        translations={(word) => this.translations(word)}
                        countryList= {this.props.countryList}
                        getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                        accountCountryList= {this.props.accountCountryList}
                        getProductRelatedTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                      />
                    : null
                  }
                  {
                    this.state.metaData.static_text_eChannelReporting !== undefined
                    && this.state.data.interestEnhancement !== undefined
                    ? <EchannelReporting
                        data={this.state.data}
                        echannels={this.state.originalData}
                        pageJson={this.state.metaData.static_text_eChannelReporting}
                        translations={(word) => this.translations(word)}
                        countryList= {this.props.countryList}
                        getCountryTaxonomy={(item) => this.getCountryTaxonomy(item)}
                      />
                    : null
                  }
                  {
                      this.state.metaData.staticText_previewIETierSetting !== undefined && this.state.metaData.staticText_previewBalanceTiers !== undefined
                      ? <IeTierAndSetting
                          data={this.state.data}
                          pageJson={this.state.metaData.staticText_previewIETierSetting}
                          pageJsonBalanceTier={this.state.metaData.staticText_previewBalanceTiers}
                          translations={(word) => this.translations(word)}
                        />
                      : null
                  }
                  {
                    this.state.metaData.staticText_previewDetailedSetting !== undefined
                    ? <DetailedSetting
                        data={this.state.data}
                        pageJson={this.state.metaData.staticText_previewDetailedSetting}
                        translations={(word) => this.translations(word)}
                        translateWordForOption={(word) => this.translateWordForOption(word)}
                        accountCountryList= {this.props.accountCountryList}
                        getProductRelatedTaxonomy={(item) => this.getProductRelatedTaxonomy(item)}
                      />
                    : null
                  }
                </NavListAccordion>
              </NavListAccordionWrapper>
            </div>
            <div className="gdoc-supportdoc-footer-btn ie-footer-button">
              <button
                onClick={() => this.eventToGoCase()}
                className="gdocs-btn-primary case-history-btn"
                name="supportingDoc"
              >
                {Translations(this.state.pageJson.button_addnbutton.text,this.props.lang.currentLang.lang, this.props.lang.translatedData)}
              </button>
            </div>
          </div>
        </div>);
      }else {
        return null;
      }
  }
}

PreviewIE.propTypes = {
  data :  PropTypes.object
};

const mapStateToProps = state => {
  return {
    lang: state.lang
  }
}

const mapDispatchToProps = dispatch => {
  return {
    setDarkTitleBarContent: (...args) => {
      dispatch(setDarkTitleBarContent(...args))
    },
    setLandingActiveTab: (activeTabId) => {
      dispatch(setLandingActiveTab(activeTabId));
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(PreviewIE);



// WEBPACK FOOTER //
// ./src/components/CaseList/PreviewGLS/IEPreview/PreviewIE.js